import { Component, OnInit, Input } from '@angular/core';
import numeral from 'numeral';
import * as _ from 'lodash-es';

@Component({
    selector: 'recap-income-applicant',
    templateUrl: './recap-income-applicant.component.html',
    styleUrls: ['./recap-income-applicant.component.scss'],
    standalone: false
})
export class RecapIncomeApplicantComponent implements OnInit {

    @Input() incomeApplicant: Object;
    public employmentIncome = [];
    public selfEmploymentIncome = [];
    public otherIncome = [];

    /**
     * Populate the income details.
     *
     * @memberof RecapIncomeApplicantComponent
     */
    populateIncomeDetails() {

        // Default the applicant to an array or the incomes.
        const incomeApplicant = _.defaultTo(this.incomeApplicant['IncomeDetails'], []);

        // Cache emp, self emp and other.
        const employmentDetails = _.defaultTo(incomeApplicant['EmploymentDetails'], []);
        const selfEmploymentDetails = _.defaultTo(incomeApplicant['SelfEmploymentDetails'], []);
        const otherEmploymentDetails = _.defaultTo(incomeApplicant['OtherIncome'], []);


        // Create the employment Incomes
        this.employmentIncome = _.transform(employmentDetails, (iter, n) => {
            const obj = {};
            obj['Value'] = '£' + numeral(_.defaultTo(n['Value'], '')).format('0,0[.]00');
            obj['Description'] = n['Description'] + ' (monthly)';
            iter.push(obj);
            return true;
        }, []);

        // Create the self employment incomes.
        this.selfEmploymentIncome = _.transform(selfEmploymentDetails, (iter, n) => {
            const obj = {};
            obj['Value'] = '£' + numeral(_.defaultTo(n['Value'], '')).format('0,0[.]00');
            obj['Description'] = _.isNil(n['Description']) ? 'Company name not given'
                : n['Description'] + ' (annual)';
            iter.push(obj);
            return true;
        }, []);

        // Create the other incomes.
        this.otherIncome = _.transform(otherEmploymentDetails, (iter, n) => {
            const obj = {};

            // Cache the description
            let Description = n['Description'];

            // Server will send back null if no value. (Refactored code here to reduce complexity)
            let Value = _.defaultTo(n['Value'], 'N/A');

            // Is the income annual, cache here for readability
            const period = ['Investments', 'Rental'].indexOf(Description) !== -1 ? '(annual)' : '(monthly)';

            // Is the person unemployed?
            const isUnemployed = Description === 'Unemployed';

            // Ifs to prevent unnecessary ternary returns.
            if (Value !== 'N/A') {
                Value = '£' + numeral(Value).format('0,0[.]00');
            }
            if (!isUnemployed) {
                Description = Description + ' ' + period;
            }

            // Use object shorthand because it's awesome..
            iter.push({
                Description,
                Value
            });
            return true;
        }, []);
    }

    /**
     * Creates an instance of RecapIncomeApplicantComponent.
     * @memberof RecapIncomeApplicantComponent
     */
    constructor() { }

    /**
     * Implement OnInit.
     *
     * @memberof RecapIncomeApplicantComponent
     */
    ngOnInit() {
        this.populateIncomeDetails();
    }

}
